<app-modal-v2 #modal customClassName="element-message-modal">
  @if (element) {
    <div class="modal-content">
      <div class="modal-body">
        <div class="title-culture-select">
          <h2 class="modal-title">{{ editing ? 'Edit Dynamic Notification' : 'New Dynamic Notification' }}</h2>

          <div class="culture-select">
            <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
          </div>
        </div>

        <div class="form-container">
          <form [formGroup]="form" [class.visibility-hidden]="!isSelectedCulture('en')">
            <!-- Start: Checkboxes and Style -->
            <div class="checkboxes-style">
              <app-checkbox formControlName="active" label="Active" [boldLabel]="true" textSize="sm"></app-checkbox>
              <app-checkbox formControlName="showInSummary" label="Show in Summary" [boldLabel]="true" textSize="sm"></app-checkbox>

              <div class="style-select">
                <label>Style</label>
                <app-input-select
                  [items]="styleOptions"
                  [parentForm]="form"
                  controlName="style"
                ></app-input-select>
              </div>
            </div>
            <!-- End: Checkboxes and Style -->

            <!-- Start: Operator and Patient Choices -->
            <div class="operator-choices">
              @if (element.elementType === DiaryFormElementType.Checkbox) {
                <div class="operator-container">
                  <label>Operator <sup>*</sup></label>
                  <app-input-select
                    [items]="operatorOptions"
                    [parentForm]="form"
                    controlName="operator"
                  ></app-input-select>
                </div>
              }

              <div class="choices-container">
                <label>Patient Choice <sup>*</sup></label>
                @if (element.elementType === DiaryFormElementType.Checkbox) {
                  <app-input-multi-select inputPlaceholder="Please select..." [parentForm]="form" controlName="patientChoices" [items]="choiceOptions"></app-input-multi-select>
                } @else {
                  <app-input-select
                    #choiceSelect
                    (valueChanged)="onPatientChoiceChanged($event)"
                    [items]="choiceOptions"
                    [parentForm]="form"
                    controlName="patientChoice"
                    inputPlaceholder="Please select..."
                  ></app-input-select>
                }
              </div>
            </div>
            <!-- End: Operator and Patient Choices -->

            @if (visibilityMessage) {
              <pgo-callout size="sm" variant="warning"><span>Visible when patient selection is <span [innerHTML]="visibilityMessage"></span></span></pgo-callout>
            }

          </form>

          <div class="message-container">
            <label>Notification Text ({{ selectedCultureName }})
              @if (isSelectedCulture('en')) {
                <sup>*</sup>
              }
            </label>

            @for (cultureForm of cultureForms; track cultureForm.get('culture').value) {
              <form [formGroup]="cultureForm" [class.visibility-hidden]="!isSelectedCulture(cultureForm.get('culture').value)">
                <textarea formControlName="text"></textarea>

                <ul class="tokens">
                  <li><strong>&#123;site_phone&#125;</strong> Site Telephone Number</li>
                </ul>
              </form>
            }
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="modal-footer-buttons">
          <app-button text="Cancel" variant="secondary" width="fill"
                      type="button" (click)="hide()"/>

          <app-button text="Apply" (clicked)="onHandleApply()" [disabled]="!isFormValid()" variant="primary"
                      width="fill"
                      type="button"/>
        </div>
      </div>

    </div>
  }
</app-modal-v2>
